/**
 * サービスタイプ
 */
export var ServiceTypes;

(function (ServiceTypes) {
  /**
   * 製品版
   */
  ServiceTypes[ServiceTypes["Enterprise"] = 0] = "Enterprise";
  /**
   * スターター版
   */

  ServiceTypes[ServiceTypes["Starter"] = 1] = "Starter";
})(ServiceTypes || (ServiceTypes = {}));